/**
 * ItemText — label do item de menu no sidebar azul.
 *
 * Estados visuais:
 *   - Padrão: texto branco translúcido (`rgba(255,255,255,0.82)`), weight 500
 *   - Ativo / atual / submenu aberto: branco puro, weight 600
 *   - Secondary label (apelido, etc): translúcido mais sutil
 *   - "Bem-vindo, NOME" — só aparece no item de usuário, depth 0
 */
import React from 'react';
import { ListItemText } from '@mui/material';
import { ellipsis } from '../../../core/util/index';

function renderLabel(label, isUserName, depth) {
  if (!isUserName || depth > 0) return label;
  return (
    <>
      Bem-vindo,{' '}
      <span style={{ fontWeight: 700 }}>{ellipsis(label, 15)}</span>
    </>
  );
}

function ItemText(props) {
  const {
    label,
    depth,
    bold,
    hasSubmenu,
    isUserName,
    isSubmenuOpen,
    isCurrentPage,
    drawerOpen = true,
    secondaryLabel = null,
  } = props;

  // Drawer recolhido: NÃO renderiza o texto. Antes ele ficava só "escondido"
  // pelo overflow do paper, mas quando a scrollbar vertical aparecia, vazava
  // um pedaço da letra inicial pra direita do ícone. Removendo do DOM eliminamos
  // qualquer chance de overflow visível.
  if (!drawerOpen) return null;

  const isHighlighted = isCurrentPage || isSubmenuOpen;
  const isSubmenuItem = depth > 0;

  return (
    <ListItemText
      primary={renderLabel(label, isUserName, depth)}
      secondary={secondaryLabel}
      sx={{
        flexGrow: 1,
        margin: 0,
        overflow: 'hidden',
        '& .MuiListItemText-primary': {
          fontFamily: '"Montserrat", system-ui, sans-serif',
          fontSize: isSubmenuItem ? '0.84rem' : '0.9rem',
          fontWeight: bold || isHighlighted ? 600 : 500,
          color: isHighlighted ? '#ffffff' : 'rgba(255, 255, 255, 0.82)',
          letterSpacing: '0.1px',
          lineHeight: 1.35,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          transition: 'color 0.18s ease, font-weight 0.18s ease',
        },
        '& .MuiListItemText-secondary': {
          fontFamily: '"Montserrat", system-ui, sans-serif',
          fontSize: '0.72rem',
          fontWeight: 400,
          color: 'rgba(255, 255, 255, 0.55)',
          marginTop: '2px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      }}
    />
  );
}

export default ItemText;
